import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import { Modal, Button } from "react-bootstrap";

function CrearDocumentoSoporte() {
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [usuario, setUsuario] = useState('');
    const [prefijo, setPrefijo] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    const [usuarios, setUsuarios] = useState([]);
    const [parametrosFev, setParametrosFev] = useState([]);
    const [proveedorId, setProveedorId] = useState('');
    const [nombreProveedor, setNombreProveedor] = useState('');
    const [tipoProveedor, setTipoProveedor] = useState('NIT');
    const [documentoProveedor, setDocumentoProveedor] = useState('');
    const [codigoResponsabilidad, setCodigoResponsabilidad] = useState('No responsable');
    const [codigoRegimen, setCodigoRegimen] = useState('No responsable de IVA');
    const [codigoImpuesto, setCodigoImpuesto] = useState('No causa');
    const [productos, setProductos] = useState([]);
    const [conceptoSeleccionado, setConceptoSeleccionado] = useState('');
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);
    const [conceptosPago, setConceptosPago] = useState([]);
    const [observaciones, setObservaciones] = useState('');
    const [showModalProveedor, setShowModalProveedor] = useState(false);
    const [proveedores, setProveedores] = useState([]);
    const [busquedaProveedor, setBusquedaProveedor] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const proveedoresPorPagina = 10;

    // Modales de confirmación y éxito
    const [showModalConfirmarEgreso, setShowModalConfirmarEgreso] = useState(false);
    const [showModalConfirmarDian, setShowModalConfirmarDian] = useState(false);
    const [showModalExito, setShowModalExito] = useState(false);
    const [documentoIdCreado, setDocumentoIdCreado] = useState(null);
    const [numeroDocumentoCreado, setNumeroDocumentoCreado] = useState('');
    const [egresoGenerado, setEgresoGenerado] = useState(false);
    const [numeroEgresoGenerado, setNumeroEgresoGenerado] = useState('');

    // Modal para mostrar JSON/Errores
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState(''); // 'json', 'error', 'success'

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a crear documentos soporte
        const tienePermiso = userdata.up && userdata.up.includes('ver_listado_documentos_soporte');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => console.log('err: ' + error));

        axios.get('/usuarios?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setUsuarios(response.data);
            })
            .catch(error => console.log('err: ' + error));

        axios.get('/parametros-fev?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setParametrosFev(response.data);
            })
            .catch(error => console.log('err: ' + error));

        axios.get('/proveedores?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setProveedores(response.data);
            })
            .catch(error => console.log('err: ' + error));

        axios.get('/conceptos-pago?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setConceptosPago(response.data);
            })
            .catch(error => console.log('err: ' + error));
    }, []);

    const handlePrefijoChange = (e) => {
        const selectedPrefijo = getPrefijosFiltrados().find(p => p.id == e.target.value);
        setPrefijo(e.target.value);
        if (selectedPrefijo) {
            setNumeroDocumento(selectedPrefijo.numero_factura);
        }
    };

    const getPrefijosFiltrados = () => {
        return parametrosFev.filter(param => 
            param.tipo === 'Documento Soporte' && 
            param.users_id == usuario &&
            param.estado == 1
        );
    };

    const agregarConcepto = () => {
        const concepto = conceptosPago.find(c => c.id == conceptoSeleccionado);
        if (concepto) {
            const nuevoProducto = {
                id: Date.now(),
                conceptos_pago_id: concepto.id,
                codigo: concepto.codigo,
                descripcion: concepto.nombre,
                cantidad: 1,
                precio: parseFloat(concepto.precio),
                porcentaje: 0,
                impuesto: 0,
                total: parseFloat(concepto.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setConceptoSeleccionado('');
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                const descuento = (productoActualizado.precio * productoActualizado.cantidad) * (productoActualizado.porcentaje / 100);
                const totalBase = (productoActualizado.precio * productoActualizado.cantidad) - descuento;
                const totalConImpuesto = totalBase + (totalBase * (productoActualizado.impuesto / 100));
                productoActualizado.total = totalConImpuesto;
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let bruto = 0;
        let descuento = 0;
        let iva = 0;
        let pagar = 0;
        
        productosArray.forEach(producto => {
            bruto += (producto.precio * producto.cantidad);
            
            // Calcular descuento del producto
            const descuentoProducto = (producto.precio * producto.cantidad) * (producto.porcentaje / 100);
            descuento += descuentoProducto;
            
            // Calcular IVA del producto
            const baseImponible = (producto.precio * producto.cantidad) - descuentoProducto;
            const ivaProducto = baseImponible * (producto.impuesto / 100);
            iva += ivaProducto;
            
            pagar += producto.total;
        });
        
        setTotalBruto(bruto);
        setTotalPagar(pagar);
    };

    const getProveedoresFiltrados = () => {
        if (!busquedaProveedor) return proveedores;
        return proveedores.filter(proveedor => {
            const nombre = proveedor.nombre_proveedor || '';
            const documento = proveedor.numero_documento || '';
            const busqueda = busquedaProveedor.toLowerCase();
            return nombre.toLowerCase().includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getProveedoresPaginados = () => {
        const proveedoresFiltrados = getProveedoresFiltrados();
        const inicio = (paginaActual - 1) * proveedoresPorPagina;
        const fin = inicio + proveedoresPorPagina;
        return proveedoresFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getProveedoresFiltrados().length / proveedoresPorPagina);
    };

    const seleccionarProveedor = (proveedor) => {
        setProveedorId(proveedor.id);
        setNombreProveedor(proveedor.nombre_proveedor);
        setTipoProveedor(proveedor.tipo_documento || 'NIT');
        setDocumentoProveedor(proveedor.numero_documento || '');
        setCodigoResponsabilidad(proveedor.codigo_responsabilidad || 'No responsable');
        setCodigoRegimen(proveedor.codigo_regimen || 'No responsable de IVA');
        setCodigoImpuesto(proveedor.codigo_impuesto || 'No causa');
        setShowModalProveedor(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!proveedorId) {
            alert('Por favor seleccione un proveedor');
            return;
        }
        
        if (productos.length === 0) {
            alert('Debe agregar al menos un concepto de pago');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        const documentoData = {
            uid: userdata.user_id,
            parametrosfev_id: parseInt(prefijo),
            users_id: parseInt(usuario),
            proveedor_id: parseInt(proveedorId),
            fecha_emision: fecha,
            forma_pago: metodoPago,
            valor_bruto: parseFloat(totalBruto),
            valor_total: parseFloat(totalPagar),
            observaciones: observaciones || '',
            detalle: productos.map(producto => ({
                conceptos_pago_id: parseInt(producto.conceptos_pago_id),
                cantidad: parseInt(producto.cantidad),
                precio_unitario: parseFloat(producto.precio),
                porcentaje: parseFloat(producto.porcentaje),
                impuesto: parseFloat(producto.impuesto),
                total: parseFloat(producto.total)
            }))
        };

        try {
            const response = await axios.post('/documento-soporte', documentoData);
            if (response.status === 200 || response.status === 201) {
                const documentoId = response.data.documento_id;
                const numeroDoc = response.data.numero_documento || documentoId;
                
                // Guardar datos del documento creado
                setDocumentoIdCreado(documentoId);
                setNumeroDocumentoCreado(numeroDoc);
                
                // Mostrar modal para preguntar si quiere generar egreso
                setShowModalConfirmarEgreso(true);
            }
        } catch (error) {
            console.error('Error completo:', error);
            alert('Error al guardar el documento soporte: ' + (error.response?.data?.message || error.message));
        }
    };

    // Función para generar egreso
    const generarEgreso = async () => {
        setShowModalConfirmarEgreso(false);
        
        try {
            const egresoResponse = await axios.post('/documento-soporte/generar-egreso', {
                documento_soporte_id: documentoIdCreado
            });
            
            if (egresoResponse.status === 200 || egresoResponse.status === 201) {
                setEgresoGenerado(true);
                setNumeroEgresoGenerado(egresoResponse.data.numero_egreso);
                
                // Mostrar modal para preguntar si quiere enviar a DIAN
                setShowModalConfirmarDian(true);
            }
        } catch (egresoError) {
            console.error('Error al generar egreso:', egresoError);
            alert('Error al generar egreso: ' + (egresoError.response?.data?.message || egresoError.message));
        }
    };

    // Función para no generar egreso y pasar a DIAN
    const noGenerarEgreso = () => {
        setShowModalConfirmarEgreso(false);
        setEgresoGenerado(false);
        
        // Mostrar modal para preguntar si quiere enviar a DIAN
        setShowModalConfirmarDian(true);
    };

    // Función para enviar a DIAN
    const enviarDian = async () => {
        setShowModalConfirmarDian(false);
        
        try {
            const envioResponse = await axios.post(`/documento-soporte/${documentoIdCreado}/enviar-dian`, {});
            
            if (envioResponse.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Documento soporte enviado exitosamente a la DIAN',
                    cufe: envioResponse.data.uuid,
                    estado: envioResponse.data.estado,
                    documentoId: documentoIdCreado
                });
                setShowModalDebug(true);
            } else {
                setDebugType('error');
                setDebugData({
                    message: envioResponse.data.message,
                    response: envioResponse.data.response,
                    json_enviado: envioResponse.data.json_enviado,
                    status_code: envioResponse.data.status_code,
                    documentoId: documentoIdCreado
                });
                setShowModalDebug(true);
            }
        } catch (envioError) {
            console.error('Error al enviar a DIAN:', envioError);
            
            // Mostrar modal de error
            setDebugType('error');
            setDebugData({
                message: envioError.response?.data?.message || envioError.message,
                error: envioError.response?.data?.error,
                response: envioError.response?.data?.response,
                json_enviado: envioError.response?.data?.json_enviado,
                fullError: envioError.response?.data,
                documentoId: documentoIdCreado
            });
            setShowModalDebug(true);
        }
        
        // Limpiar formulario
        limpiarFormulario();
    };

    // Función para no enviar a DIAN
    const noEnviarDian = () => {
        setShowModalConfirmarDian(false);
        
        // Mostrar modal de éxito
        setShowModalExito(true);
    };

    // Función para limpiar el formulario
    const limpiarFormulario = () => {
        setProductos([]);
        setProveedorId('');
        setNombreProveedor('');
        setDocumentoProveedor('');
        setObservaciones('');
        setTotalBruto(0);
        setTotalPagar(0);
        setPrefijo('');
        setNumeroDocumento('');
    };

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item"><Link to="/listado-documentos-soporte">Listado de Documentos Soporte</Link></li>
                                        <li className="breadcrumb-item active">Crear Documento Soporte</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Crear Documento Soporte</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <h5><b>Información del Documento Soporte</b></h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        
                                        <h5><b>Información del Proveedor</b></h5>
                                        
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Nombre *</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        value={nombreProveedor}
                                                        readOnly
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>Tipo *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={tipoProveedor}
                                                        disabled
                                                        required
                                                    >
                                                        <option value="NIT">NIT</option>
                                                        <option value="CC">CC</option>
                                                        <option value="CE">CE</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>N° Documento *</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        value={documentoProveedor}
                                                        readOnly
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-1">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-info form-control"
                                                        onClick={() => setShowModalProveedor(true)}
                                                    >
                                                        <i className="fas fa-search"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Responsabilidad *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={codigoResponsabilidad}
                                                        onChange={(e) => setCodigoResponsabilidad(e.target.value)}
                                                        required
                                                    >
                                                        <option>No responsable</option>
                                                        <option>Régimen simple de tributación</option>
                                                        <option>Gran contribuyente</option>
                                                        <option>Autorretenedor</option>
                                                        <option>Agente de retención IVA</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Tipo de Régimen *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={codigoRegimen}
                                                        onChange={(e) => setCodigoRegimen(e.target.value)}
                                                        required
                                                    >
                                                        <option>No responsable de IVA</option>
                                                        <option>Impuesto sobre las ventas / IVA</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Impuesto *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={codigoImpuesto}
                                                        onChange={(e) => setCodigoImpuesto(e.target.value)}
                                                        required
                                                    >
                                                        <option>No causa</option>
                                                        <option>IVA</option>
                                                        <option>INC</option>
                                                        <option>IVA e INC</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <hr />

                                        <h5><b>Datos del Documento</b></h5>

                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Fecha Emisión *</label>
                                                    <input 
                                                        type="date" 
                                                        className="form-control" 
                                                        value={fecha}
                                                        onChange={(e) => setFecha(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Método de Pago *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={metodoPago}
                                                        onChange={(e) => setMetodoPago(e.target.value)}
                                                        required
                                                    >
                                                        <option value="10">Efectivo</option>
                                                        <option value="42">Consignación bancaria</option>
                                                        <option value="48">Tarjeta Crédito</option>
                                                        <option value="49">Tarjeta Débito</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Prefijo *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={prefijo}
                                                        onChange={handlePrefijoChange}
                                                        required
                                                    >
                                                        <option value="">Seleccionar...</option>
                                                        {getPrefijosFiltrados().map(p => (
                                                            <option key={p.id} value={p.id}>{p.prefijo}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>N° Documento *</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        value={numeroDocumento}
                                                        readOnly
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Usuario que Emite *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={usuario}
                                                        onChange={(e) => setUsuario(e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Seleccionar usuario...</option>
                                                        {usuarios.map(u => (
                                                            <option key={u.id} value={u.id}>{u.name} {u.lastname}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <hr />

                                        <h5><b>Conceptos de Pago</b></h5>

                                        <div className="row">
                                            <div className="col-md-10">
                                                <div className="form-group">
                                                    <label>Selecciona el Concepto</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={conceptoSeleccionado}
                                                        onChange={(e) => setConceptoSeleccionado(e.target.value)}
                                                    >
                                                        <option value="">Seleccionar...</option>
                                                        {conceptosPago.map(concepto => (
                                                            <option key={concepto.id} value={concepto.id}>
                                                                {concepto.codigo} - {concepto.nombre}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-info form-control"
                                                        onClick={agregarConcepto}
                                                    >
                                                        Agregar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Código</th>
                                                        <th>Descripción</th>
                                                        <th>Cant.</th>
                                                        <th>Precio</th>
                                                        <th>Desc %</th>
                                                        <th>IVA %</th>
                                                        <th>Total</th>
                                                        <th>Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {productos.map(producto => (
                                                        <tr key={producto.id}>
                                                            <td>{producto.codigo}</td>
                                                            <td>{producto.descripcion}</td>
                                                            <td>
                                                                <input 
                                                                    type="number" 
                                                                    className="form-control form-control-sm" 
                                                                    value={producto.cantidad}
                                                                    onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                    min="1"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input 
                                                                    type="number" 
                                                                    className="form-control form-control-sm" 
                                                                    value={producto.precio}
                                                                    onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                    step="0.01"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input 
                                                                    type="number" 
                                                                    className="form-control form-control-sm" 
                                                                    value={producto.porcentaje}
                                                                    onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                    min="0"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input 
                                                                    type="number" 
                                                                    className="form-control form-control-sm" 
                                                                    value={producto.impuesto}
                                                                    onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                    min="0"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input 
                                                                    type="number" 
                                                                    className="form-control form-control-sm" 
                                                                    value={parseFloat(producto.total || 0).toFixed(2)}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td>
                                                                <button 
                                                                    type="button" 
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() => eliminarProducto(producto.id)}
                                                                >
                                                                    ×
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr style={{borderTop: '2px solid #dee2e6'}}>
                                                        <td colSpan="6" className="text-right" style={{border: 'none', paddingTop: '15px'}}><strong>Subtotal:</strong></td>
                                                        <td colSpan="2" style={{border: 'none', paddingTop: '15px'}}>
                                                            <input 
                                                                type="text" 
                                                                className="form-control" 
                                                                value={`$ ${parseFloat(totalBruto || 0).toFixed(2)}`}
                                                                readOnly
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="6" className="text-right" style={{border: 'none'}}><strong>Descuento:</strong></td>
                                                        <td colSpan="2" style={{border: 'none'}}>
                                                            <input 
                                                                type="text" 
                                                                className="form-control" 
                                                                value={`$ 0,00`}
                                                                readOnly
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="6" className="text-right" style={{border: 'none'}}><strong>IVA:</strong></td>
                                                        <td colSpan="2" style={{border: 'none'}}>
                                                            <input 
                                                                type="text" 
                                                                className="form-control" 
                                                                value={`$ 0,00`}
                                                                readOnly
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="6" className="text-right" style={{border: 'none'}}><strong>Total:</strong></td>
                                                        <td colSpan="2" style={{border: 'none'}}>
                                                            <input 
                                                                type="text" 
                                                                className="form-control" 
                                                                value={`$ ${parseFloat(totalPagar || 0).toFixed(2)}`}
                                                                readOnly
                                                            />
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>

                                        <hr />

                                        <div className="form-group">
                                            <label>Observaciones</label>
                                            <textarea 
                                                className="form-control" 
                                                rows="3"
                                                value={observaciones}
                                                onChange={(e) => setObservaciones(e.target.value)}
                                                placeholder="Observaciones del documento..."
                                            ></textarea>
                                        </div>

                                        <div className="form-group">
                                            <button type="submit" className="btn btn-info mr-2">
                                                <i className="fas fa-save"></i> Guardar Documento Soporte
                                            </button>
                                            <Link to="/listado-documentos-soporte" className="btn btn-secondary">
                                                <i className="fas fa-arrow-left"></i> Cancelar
                                            </Link>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                {showModalProveedor && (
                    <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Seleccionar Proveedor</h5>
                                    <button type="button" className="close" onClick={() => setShowModalProveedor(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Buscar por nombre o documento..."
                                            value={busquedaProveedor}
                                            onChange={(e) => {
                                                setBusquedaProveedor(e.target.value);
                                                setPaginaActual(1);
                                            }}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Documento</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getProveedoresPaginados().map((proveedor, index) => (
                                                    <tr key={index}>
                                                        <td>{proveedor.nombre_proveedor}</td>
                                                        <td>{proveedor.numero_documento}</td>
                                                        <td>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => seleccionarProveedor(proveedor)}
                                                            >
                                                                Seleccionar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    {getTotalPaginas() > 1 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === 1}
                                                onClick={() => setPaginaActual(paginaActual - 1)}
                                            >
                                                Anterior
                                            </button>
                                            <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === getTotalPaginas()}
                                                onClick={() => setPaginaActual(paginaActual + 1)}
                                            >
                                                Siguiente
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalProveedor(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Confirmar Egreso */}
                <Modal show={showModalConfirmarEgreso} onHide={() => setShowModalConfirmarEgreso(false)} centered>
                    <Modal.Header closeButton className="bg-info text-white">
                        <Modal.Title>
                            <i className="fas fa-check-circle mr-2"></i>
                            Documento Guardado
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-4">
                        <div className="mb-3">
                            <i className="fas fa-check-circle text-success" style={{ fontSize: '3rem' }}></i>
                        </div>
                        <h5 className="mb-3">Documento soporte guardado exitosamente</h5>
                        <div className="alert alert-info">
                            <strong>Número de Documento:</strong> {numeroDocumentoCreado}
                        </div>
                        <div className="alert alert-warning">
                            <h6><strong>¿Desea generar un EGRESO para cancelar esta cuenta por pagar?</strong></h6>
                            <ul className="text-left mt-2" style={{ fontSize: '0.9rem' }}>
                                <li><strong>SÍ:</strong> Se creará un egreso automáticamente y se marcará como PAGADA</li>
                                <li><strong>NO:</strong> Se registrará como cuenta POR PAGAR para gestionar después</li>
                            </ul>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" style={{ gap: '10px' }}>
                        <Button 
                            variant="success" 
                            onClick={generarEgreso}
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-money-bill-wave mr-2"></i>
                            Sí, Generar Egreso
                        </Button>
                        <Button 
                            variant="secondary" 
                            onClick={noGenerarEgreso}
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-clock mr-2"></i>
                            No, Dejar Pendiente
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Confirmar Envío a DIAN */}
                <Modal show={showModalConfirmarDian} onHide={() => setShowModalConfirmarDian(false)} centered>
                    <Modal.Header closeButton className="bg-info text-white">
                        <Modal.Title>
                            <i className="fas fa-paper-plane mr-2"></i>
                            Enviar a la DIAN
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-4">
                        {egresoGenerado && (
                            <div className="alert alert-success mb-3">
                                <i className="fas fa-check-circle mr-2"></i>
                                Egreso N° <strong>{numeroEgresoGenerado}</strong> generado exitosamente
                            </div>
                        )}
                        <h5 className="mb-3">¿Desea enviar el documento a la DIAN?</h5>
                        <p className="text-muted">
                            El documento será transmitido electrónicamente a la DIAN para su validación y registro oficial.
                        </p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" style={{ gap: '10px' }}>
                        <Button 
                            variant="primary" 
                            onClick={enviarDian}
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-paper-plane mr-2"></i>
                            Sí, Enviar
                        </Button>
                        <Button 
                            variant="secondary" 
                            onClick={noEnviarDian}
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-times mr-2"></i>
                            No Enviar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de Éxito Final */}
                <Modal show={showModalExito} onHide={() => setShowModalExito(false)} centered>
                    <Modal.Header closeButton className="bg-info text-white">
                        <Modal.Title>
                            <i className="fas fa-check-circle mr-2"></i>
                            Proceso Completado
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-4">
                        <div className="mb-3">
                            <i className="fas fa-check-circle text-success" style={{ fontSize: '3rem' }}></i>
                        </div>
                        <h5 className="mb-3">Documento guardado exitosamente</h5>
                        <div className="alert alert-info">
                            <strong>Número de Documento:</strong> {numeroDocumentoCreado}
                        </div>
                        {egresoGenerado && (
                            <div className="alert alert-success">
                                <strong>Egreso Generado:</strong> N° {numeroEgresoGenerado}
                            </div>
                        )}
                        <p className="text-muted">
                            {egresoGenerado 
                                ? 'El documento ha sido marcado como PAGADA' 
                                : 'El documento se registró como cuenta POR PAGAR'}
                        </p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" style={{ gap: '10px' }}>
                        <Button 
                            variant="info" 
                            onClick={() => {
                                setShowModalExito(false);
                                history.push(`/informacion-documento-soporte/${documentoIdCreado}`);
                            }}
                            style={{ minWidth: '150px' }}
                        >
                            <i className="fas fa-eye mr-2"></i>
                            Ver Información
                        </Button>
                        <Button 
                            variant="secondary" 
                            onClick={() => {
                                setShowModalExito(false);
                                history.push('/listado-documentos-soporte');
                            }}
                            style={{ minWidth: '150px' }}
                        >
                            <i className="fas fa-list mr-2"></i>
                            Ir al Listado
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Debug - Mostrar JSON/Errores */}
                {showModalDebug && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className={`modal-header ${debugType === 'success' ? 'bg-info' : 'bg-danger'} text-white`}>
                                    <h4 className="modal-title">
                                        {debugType === 'success' ? (
                                            <><i className="fas fa-check-circle mr-2"></i>Envío Exitoso</>
                                        ) : (
                                            <><i className="fas fa-exclamation-triangle mr-2"></i>Error en el Envío</>
                                        )}
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalDebug(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {debugType === 'success' ? (
                                        <div>
                                            <div className="alert alert-info">
                                                <h5><i className="fas fa-check-circle"></i> {debugData?.message}</h5>
                                            </div>
                                            <div className="card border-info">
                                                <div className="card-header bg-info text-white">
                                                    <strong><i className="fas fa-info-circle mr-2"></i>Detalles de la Respuesta</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p><strong>CUFE:</strong> <code style={{fontSize: '0.9em'}}>{debugData?.cufe}</code></p>
                                                    <p><strong>Estado del Documento:</strong> 
                                                        <span className="badge badge-info ml-2">
                                                            Enviado a DIAN
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            {debugData?.documentoId && (
                                                <div className="mt-3">
                                                    <button 
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => window.location.href = '/#/listado-documentos-soporte'}
                                                    >
                                                        <i className="fas fa-list"></i> Ir al Listado
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="alert alert-danger">
                                                <h5><i className="fas fa-exclamation-triangle"></i> {debugData?.message}</h5>
                                            </div>
                                            
                                            {debugData?.response && (
                                                <div className="card mb-3">
                                                    <div className="card-header bg-warning">
                                                        <strong><i className="fas fa-exclamation-triangle mr-2"></i>Respuesta de la DIAN</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '15px',
                                                            borderRadius: '4px',
                                                            maxHeight: '400px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordWrap: 'break-word'
                                                        }}>{JSON.stringify(debugData.response, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {debugData?.json_enviado && (
                                                <div className="card mb-3">
                                                    <div className="card-header bg-primary text-white">
                                                        <strong><i className="fas fa-code mr-2"></i>JSON Enviado a la DIAN</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '15px',
                                                            borderRadius: '4px',
                                                            maxHeight: '400px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordWrap: 'break-word'
                                                        }}>{JSON.stringify(debugData.json_enviado, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {debugData?.status_code && (
                                                <div className="alert alert-warning">
                                                    <strong>Código de Estado HTTP:</strong> {debugData.status_code}
                                                </div>
                                            )}
                                            
                                            {/* Botones de navegación para errores */}
                                            {debugData?.documentoId && (
                                                <div className="mt-3">
                                                    <button 
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => window.location.href = '/#/listado-documentos-soporte'}
                                                    >
                                                        <i className="fas fa-list"></i> Ir al Listado
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default CrearDocumentoSoporte;
